import React from 'react'

export default (
  <svg fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M9,5v2h6.59L4,18.59L5.41,20L17,8.41V15h2V5H9z"
    />
  </svg>
)
